import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";
import { adminFetch } from "../utils/adminAuth";

export default function AdminContactMessages() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        adminFetch(`${API_BASE}/api/get_contact_messages.php`)
            .then((r) => r.json())
            .then((data) => { if (data.success) setRows(data.messages); })
            .finally(() => setLoading(false));
    };

    useEffect(load, []);

    const setStatus = async (id, status) => {
        setRows((prev) => prev.map((r) => (r.id === id ? { ...r, status } : r)));
        await adminFetch(`${API_BASE}/api/update_contact_message.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, status }),
        });
    };

    const badge = (status) => {
        const map = { unread: "warning", read: "secondary", replied: "success" };
        return <span className={`badge bg-${map[status] || "secondary"}`}>{status}</span>;
    };

    return (
        <div>
            <h5 className="fw-bold mb-1">Contact Messages</h5>
            <p className="text-secondary small mb-3">Submissions from the public Contact Us page.</p>

            <div className="card shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="p-3">Loading...</div>
                    ) : rows.length === 0 ? (
                        <div className="p-3 text-secondary">No messages yet.</div>
                    ) : (
                        <table className="table table-sm mb-0 align-middle">
                            <thead className="table-light">
                                <tr><th>From</th><th>Subject</th><th>Message</th><th>Status</th><th>Received</th><th></th></tr>
                            </thead>
                            <tbody>
                                {rows.map((r) => (
                                    <tr key={r.id}>
                                        <td className="small">
                                            <b>{r.full_name}</b><br />
                                            <span className="text-secondary">{r.email}</span>
                                            {r.phone && <><br /><span className="text-secondary">{r.phone}</span></>}
                                        </td>
                                        <td className="small">{r.subject || "—"}</td>
                                        <td className="small" style={{ maxWidth: 320, whiteSpace: "pre-wrap" }}>{r.message}</td>
                                        <td>{badge(r.status)}</td>
                                        <td className="text-secondary small">{r.created_at}</td>
                                        <td>
                                            {r.status !== "read" && <button className="btn btn-sm btn-outline-secondary me-1" onClick={() => setStatus(r.id, "read")}>Mark Read</button>}
                                            {r.status !== "replied" && <button className="btn btn-sm btn-outline-success" onClick={() => setStatus(r.id, "replied")}>Mark Replied</button>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
